import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=12a014c2&scoped=true"
import script from "./AppContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=12a014c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a014c2",
  null
  
)

export default component.exports